import React from 'react';

import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';

interface IAreaFormFooter {
    disabled?: boolean;
    onDismiss: () => void;
    onSubmit: () => void;
}

const AreaFormFooter: React.FunctionComponent<IAreaFormFooter> = ({ disabled, onDismiss, onSubmit }) => (
    <div className="area-form-footer-container">
        <PrimaryButton type="submit" disabled={disabled} onClick={onSubmit} styles={{ root: { marginRight: 10 } }}>
            Salva
        </PrimaryButton>

        <DefaultButton disabled={disabled} onClick={onDismiss}>
            Annulla
        </DefaultButton>
    </div>
);

export default AreaFormFooter;